import { GarageOrder } from './garage-order';

/**
 * Paged orders response envelope: the rows for the requested
 * `offset`/`limit` window plus the total row count across the whole result
 * set (used to drive server-side pagination).
 *
 * NOTE: field names mirror the API response. If the backend uses different
 * keys, adjust here and in {@link mapOrderPage} — those are the only two
 * places that touch the raw envelope shape.
 */
export interface OrderPage {
  items: GarageOrder[];
  totalCount: number;
}

/** Normalizes a raw orders response into an {@link OrderPage}, tolerating a
    bare-array response (no envelope) by treating its length as the total. */
export function mapOrderPage(
  response: OrderPage | GarageOrder[] | null | undefined
): OrderPage {
  if (Array.isArray(response)) {
    return { items: response, totalCount: response.length };
  }
  return {
    items: response?.items ?? [],
    totalCount: response?.totalCount ?? 0,
  };
}
